import { CancellationReason } from '@/model';

import { BaseHttpController } from './BaseHttpController';

export class ShipmentCancellationReasonController extends BaseHttpController {
  static readonly ENDPOINT = 'shipment-cancellation-reason';

  constructor() {
    super(ShipmentCancellationReasonController.ENDPOINT);
  }

  async findAll(): Promise<CancellationReason[]> {
    const response = await this.http.get<CancellationReason[]>('');
    return response.data.map((r) => new CancellationReason(r));
  }
}
